import { ReactNode, ButtonHTMLAttributes } from "react";
import { Spinner } from "../ui/modal";

interface TextButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon?: ReactNode;
  label: ReactNode;
  loading?: boolean;
}

export const TextButton = ({
  icon,
  label,
  className,
  loading,
  ...buttonProps
}: TextButtonProps) => {
  return (
    <button
      {...buttonProps}
      className={`flex justify-center items-center gap-2 px-4 py-2.5 w-40 text-base text-white text-medium bg-i-normal shadow-[0px_1px_2px_rgba(16,24,40,0.05)] rounded-sm hover:bg-[rgba(40,47,62,1)] disabled:opacity-60 transition-all duration-200 ${className || ''}`}
    >
      {loading ? (
        <Spinner className="size-5" />
      ) : (
        <>
          {icon}
          <span>
            {label}
          </span>
        </>
      )}
    </button>
  );
};
